import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';

import { AsyncPipe, NgClass } from '@angular/common';
import { MakeProvider } from '../../../../helpers/base-control-value-accessor';
import { GetDisabledMsgPipe } from '../../../../pipes/disabled-message.pipe';
import { ShIndeterminateDirective } from '../../../directives/indeterminate.directive';
import { FormValue, FormValueState } from '../../../entities/form-value.entity';
import { ShFormCheckboxListComplexBaseComponent } from '../base-complex/form-checkbox-list-complex-base.component';

@Component({
    selector: 'sh-form-checkbox-list-base',
    templateUrl: '../base-complex/form-checkbox-list-complex-base.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [MakeProvider(ShFormCheckboxListBaseComponent)],
    standalone: true,
    imports: [NgClass, ShIndeterminateDirective, AsyncPipe, GetDisabledMsgPipe]
})
export class ShFormCheckboxListBaseComponent extends ShFormCheckboxListComplexBaseComponent {
    constructor(changeDetectorRef: ChangeDetectorRef) {
        super(changeDetectorRef);
    }

    propagateChange(formValues: FormValue<string>[]): void {
        const unwrapped: any = formValues
            .filter(fv => fv.state === FormValueState.SET)
            .map(FormValue.unwrap.bind(this));
        super.propagateChange(unwrapped);
    }

    writeValue(obj: any[]): void {
        const base: any[] = obj instanceof Array ? obj : [];
        super.writeValue(base.map(el => FormValue.wrap(el)));
    }
}
